import { UserSubscriptionStripeConnectStatus } from '../../../../ReduxStorage/UserSubscriptionPlans/constants';
import { ChipVariant } from '../../../components/Chip/component';
import { SelectOption } from '../../../components/Select/component';
import { Countries } from './constants';

export const getChipVariantFromStripeConnectStatus = (
  status: UserSubscriptionStripeConnectStatus
): ChipVariant => {
  switch (status) {
    case 'active':
      return 'success';
    case 'pending':
      return 'warning';
    case 'no_stripe_account':
    case 'no_revenue_share':
    default:
      return 'default';
  }
};

export const makeCountryOptions = (): SelectOption[] => {
  const emptyOption: SelectOption = {
    label: 'Please choose a country',
    value: '',
  };
  return [emptyOption].concat(
    Countries.map((country) => ({
      label: `${country.name} (${country.code})`,
      value: country.code,
    }))
  );
};
